import { render } from "./UIButton.vue?vue&type=template&id=5170afec&scoped=true"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"

import "./UIButton.vue?vue&type=style&index=0&id=5170afec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5170afec"]])

export default __exports__